import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { useIntl } from '@atlassian/jira-intl';
import { useFeatures } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/controllers/features/main.tsx';
import { ReportsHomePage, NoPermsEmptyState } from '@atlassian/jsm-enterprise-reports-common';
import { useReportsHomePageController } from '../controllers/home-page-controller';
import messages from './messages';
import type { Props } from './types';

const HomePageSpa = ({ pageContext }: Props) => {
	const { projectKey } = pageContext;
	const { reportsConfig, loading } = useReportsHomePageController(projectKey);
	const { formatMessage } = useIntl();
	const { data: features } = useFeatures();

	const isEmpty = reportsConfig.reduce(
		(accumulator, currentValue) => accumulator && !currentValue.access,
		true,
	);

	if ((isEmpty && reportsConfig.length > 0) || !features?.hasReports) {
		return (
			<EmptyState
				header={formatMessage(messages.emptyStateHeader)}
				description={formatMessage(messages.emptyStateDescription)}
				headingLevel={3}
				imageUrl={NoPermsEmptyState}
			/>
		);
	}

	if (loading) {
		return (
			<Box xcss={spinnerContainer}>
				<Spinner size="large" />
			</Box>
		);
	}

	return (
		<Box xcss={filtersAndViewContainer}>
			<ReportsHomePage reportsConfig={reportsConfig} extraFilters={[]} />
		</Box>
	);
};

export default HomePageSpa;

const filtersAndViewContainer = xcss({
	display: 'flex',
	marginTop: 'space.600',
	flexDirection: 'row',
	justifyContent: 'space-between',
	marginBottom: 'space.200',
});

const spinnerContainer = xcss({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100%',
	marginTop: 'space.500',
});
